module.exports = __webpack_public_path__ + "312dd4fbf4b3c9b3faacc771c402cb81.webp";